(() => {
  'use strict';
  const setup = (root) => {
    if (root.dataset.tkHomeReady) return;
    root.dataset.tkHomeReady = 'true';
    let timer;
    const expire = () => {
      window.clearTimeout(timer);
      if (!root.isConnected) return;
      let next = 60000;
      const now = Date.now();
      root.querySelectorAll('[data-tk-home-stock-card]:not([hidden])').forEach((card) => {
        const remaining = Number(card.dataset.tkHomeExpires) - now;
        if (Number.isFinite(remaining) && remaining > 0) {
          next = Math.min(next, remaining);
        } else {
          if (card.contains(document.activeElement)) root.querySelector('.tk-home-selection h2').focus({ preventScroll: true });
          card.hidden = true;
        }
      });
      const available = root.querySelector('[data-tk-home-stock-card]:not([hidden])');
      root.querySelector('[data-tk-home-stock-content]').hidden = !available;
      root.querySelector('[data-tk-home-stock-fallback]').hidden = Boolean(available);
      if (available) timer = window.setTimeout(expire, Math.max(50, next));
    };
    expire();
    document.addEventListener('visibilitychange', expire);
    window.addEventListener('pageshow', expire);
  };
  document.querySelectorAll('[data-tk-home]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-tk-home]').forEach(setup));
})();
